import { render, staticRenderFns } from "./StatusInstrument.vue?vue&type=template&id=887742b0&"
import script from "./StatusInstrument.vue?vue&type=script&lang=ts&"
export * from "./StatusInstrument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports